export enum SignVerifyType {
  JOINT_CERT = '1', // 공동인증서
  DIGITAL_CERT = '9', // 디지털인증서
  FIN_CERT_PIN = 'B', // 금융인증서(간편비밀번호)
  FIN_CERT_BIO = 'C', // 금융인증서(지문/안면인식)
  FIN_TECH_TOSS = 'D', // 핀테크인증서(토스)
}
export enum SignActionType {
  LOGIN = 'L',
  SIGN = 'S',
  // AUTH = 'A', // (미사용) 공동인증서 본인인증
  // NTB_SIGN = 'NS', (미사용) 신규가입 서명
  // GOV = 'G' // (미사용) 공공데이터,
  // SCRAP = 'S' // (미사용) 스크래핑
}
export enum SignResultCode {
  SUCCESS = '0',
  FAIL = '1',
  SKIP = '8',
  CANCEL = '9',
}

export enum FinTechProvider {
  TOSS = 'toss', // 토스
  // KAKAO = 'kakao', // (ASIS 미사용)
}
